import type { DefaultTheme } from 'styled-components'

import { colors } from './colors'
import { typography } from './typography'

export const moonsTheme: DefaultTheme = {
  colors,
  typography,
}
